import React, { useEffect } from "react";
import { Fragment } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Loading from "../../Components/Common/Loading/Loading";
import BorderBox from "../../_Components/Common/BoxUI/BorderBox";
import PageTitle from "../../_Components/Common/PageTitle/PageTitle";
import MessageNoticeAddForm from "../../_Components/MessageCenter/MessageNotice/MessageNoticeAddForm";
import MessageNoticeAddPreview from "../../_Components/MessageCenter/MessageNotice/MessageNoticeAddPreview";

const Wrapper = styled.div`
  width: 100%;
  padding-bottom: 15px;
`;

const Inner = styled.div`
  display: flex;
  width: 100%;
`;

const InnerLeft = styled.div`
  display: flex;
  width: 100%;
`;

const InnerRight = styled.div`
  display: flex;
  min-width: 780px;
  max-width: 780px;
  width: 780px;
`;

const MessageNoticeAddPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [previewData, setPreviewData] = useState(null);

  const history = useHistory();

  useEffect(() => {
    if (window.sessionStorage.getItem("token")) {
      setIsLoading(false);
    } else {
      history.push("/");
    }
  }, []);

  const goTop = () => {
    document
      .getElementsByClassName("wrapper")[0]
      .scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Wrapper>
      <PageTitle
        mainTitle={"Notice - Add"}
        v1Link={""}
        navNames={["Management", "Message Center", "Notice", "Add"]}
      />
      {isLoading && <Loading />}
      {!isLoading && (
        <Fragment>
          <Inner>
            <InnerLeft>
              <BorderBox
                boxTitle={"Notice Form"}
                component={
                  <MessageNoticeAddForm
                    setPreviewData={(formData) => {
                      setPreviewData(formData);
                    }}
                    goTop={goTop}
                  />
                }
              />
            </InnerLeft>
            <InnerRight>
              <BorderBox
                boxTitle={"Notice Preview"}
                component={
                  <MessageNoticeAddPreview
                    previewData={previewData}
                    goTop={goTop}
                  />
                }
              />
            </InnerRight>
          </Inner>
        </Fragment>
      )}
    </Wrapper>
  );
};

export default MessageNoticeAddPage;
